export const MainNav = [
  {
    icon: 'pe-7s-home',
    label: 'Home',
    to: '#/dashboard'
  },
  {
    icon: 'pe-7s-display1',
    label: 'Campaigns',
    content: [
      {
        label: 'Create campaign',
        to: '#/campaigns/create',
      },
      {
        label: 'List campaigns',
        to: '#/campaigns',
      },
    ],
  },
  {
    icon: 'pe-7s-music',
    label: 'Create Video',
    to: '#/create-video'
  },
  {
    icon: 'pe-7s-user',
    label: 'Account',
    to: '#/account'
  },
  {
    icon: 'pe-7s-help1',
    label: 'Help',
    to: '#/help'
  },
];

export const CampaignNav = [
  {
    icon: 'pe-7s-display1',
    label: 'Overview',
    to: '#/campaign'
  },
  {
    icon: 'pe-7s-config',
    label: 'Edit',
    to: '#/campaign/edit'
  },
  {
    icon: 'pe-7s-video',
    label: 'Videos',
    to: '#/campaign/manage'
  },
  {
    icon: 'pe-7s-music',
    label: 'Create Video',
    to: '#/campaign/create-video'
  },
  {
    icon: 'pe-7s-share',
    label: 'Share',
    to: '#/campaign/share'
  },
  {
    icon: 'pe-7s-graph1',
    label: 'Analyze',
    to: '#/campaign/analyze'
  }
];